import React, { useEffect, useState, useRef } from "react";
import { Activity } from "lucide-react";
import { api } from "@/lib/api";
import { getChain, fmtNum, fmtUsd, shorten } from "@/lib/chains";

// Rolling live on-chain transaction feed for the lock / launch screen.
export default function LiveTxFeed() {
  const [pool, setPool] = useState([]);
  const [visible, setVisible] = useState([]);
  const idx = useRef(0);

  const fetchFeed = async () => {
    try {
      const { data } = await api.get("/live/transactions");
      if (Array.isArray(data) && data.length) {
        setPool(data);
        idx.current = 0;
        setVisible(data.slice(0, 5));
      }
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    fetchFeed();
    const refetch = setInterval(fetchFeed, 9000);
    return () => clearInterval(refetch);
  }, []);

  // advance the window every 2.4s so it feels live
  useEffect(() => {
    if (pool.length < 6) return;
    const t = setInterval(() => {
      idx.current = (idx.current + 1) % pool.length;
      const win = [];
      for (let i = 0; i < 5; i++) win.push(pool[(idx.current + i) % pool.length]);
      setVisible(win);
    }, 2400);
    return () => clearInterval(t);
  }, [pool]);

  if (!visible.length) return null;

  return (
    <div className="w-full">
      <div className="mb-2 flex items-center justify-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#10B981] opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#10B981]" />
        </span>
        <p className="font-rajdhani text-xs uppercase tracking-[0.3em] text-[#9CA3AF]">Live on-chain activity</p>
      </div>
      <div className="space-y-1.5">
        {visible.map((t, i) => {
          const chain = getChain(t.chain);
          return (
            <div
              key={`${t.hash}-${i}`}
              className="flex items-center gap-3 rounded-xl border border-[#1F2430] bg-[#12141A]/80 px-3 py-2 fade-up"
            >
              <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: chain?.color, boxShadow: `0 0 8px ${chain?.color}` }} />
              <div className="min-w-0 flex-1 text-left">
                <p className="font-rajdhani text-sm font-semibold text-white">
                  {fmtNum(t.amount, 5)} <span style={{ color: chain?.color }}>{t.symbol}</span>
                </p>
                <p className="truncate font-rajdhani text-[10px] text-[#6B7280]">{shorten(t.hash, 10)}</p>
              </div>
              <span className="shrink-0 font-rajdhani text-xs font-semibold text-[#10B981]">{fmtUsd(t.usd)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
